import { Base } from './base';

export class ChoiceAnswerType extends Base {
	protected data = [
    {
      name: "A",
      typeVal: 1,
    },
    {
      name: 'B',
      typeVal: 2,
    },
    {
      name: 'C',
      typeVal: 3,
    },
    {
      name: 'D',
      typeVal: 4,
    }
  ];
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/choiceAnswerType.ts